/* 12.357.91 · THE STUDIO SEAL — on his words ('we need to build the ai skill cards to so one one can replicate this.' · 'go on all'). Every punch a room prints is
   signed by the studio's own key (LS-SEAL-1, Ed25519); the private half is held off every server, the public half sits here and on THE STANDARD page. This script
   reads the signature on record for the room's punch and verifies it with WebCrypto, in this browser; nothing leaves the machine. VERIFIED, FAILS or NONE ON RECORD,
   said under the punch check. The seal proves the studio signed this punch; it does not score the card. */
(function () {
  var KEY = 'Uh4k1DESk/mxhoJ/rntnA5S+0y1iVGvuzr2fGPMIpuQ=', KEYHEX = '521E24D4311293F9B186827FAE7B670394BED32D62546BEECEBD9F18F308A6E4', me = document.currentScript, SRC = me && me.getAttribute('data-seal');
  function b64(s) { var b = atob(s), u = new Uint8Array(b.length); for (var i = 0; i < b.length; i++) u[i] = b.charCodeAt(i); return u; }
  var ixp = null;
  function load() {
    if (ixp) return ixp;
    if (window.LUNDR_SEAL) ixp = Promise.resolve(window.LUNDR_SEAL);
    else if (SRC) ixp = fetch(SRC).then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.json(); });
    else ixp = Promise.reject(new Error('no index'));
    return ixp;
  }
  function verify(punch, sig) {
    if (!(window.crypto && crypto.subtle && crypto.subtle.importKey)) return Promise.reject(new Error('no webcrypto'));
    return crypto.subtle.importKey('raw', b64(KEY), { name: 'Ed25519' }, false, ['verify']).then(function (k) {
      return crypto.subtle.verify('Ed25519', k, b64(sig), new TextEncoder().encode('LUNDR STUDIO SEAL v1\n' + punch));
    });
  }
  function say(el, cls, text) { el.className = 'sealine ' + cls; el.textContent = text; }
  function place(btn) {
    var out = btn.parentNode.querySelector('.pchk-out'), el = document.createElement('p'); el.className = 'sealine'; el.setAttribute('aria-live', 'polite');
    el.textContent = 'STUDIO SEAL · CHECKING THE SIGNATURE ON RECORD…'; (out || btn).insertAdjacentElement('afterend', el); return el;
  }
  function run() {
    var btns = document.querySelectorAll('.pchk-btn[data-punch]'), els = [];
    btns.forEach(function (b) { if (b.parentNode.querySelector('.sealine')) return; els.push([String(b.dataset.punch).toUpperCase(), place(b)]); });
    if (!els.length) return;
    load().then(function (ix) {
      if (!ix || ix.key !== KEY) { els.forEach(function (e) { say(e[1], 'seal-no', 'STUDIO SEAL · THE INDEX CARRIES ANOTHER KEY · NOT VERIFIED'); }); return; }
      els.forEach(function (e) {
        var sig = ix.seals && ix.seals[e[0]];
        if (!sig) { say(e[1], 'seal-none', 'STUDIO SEAL · NONE ON RECORD FOR ' + e[0] + ' · not sealed by the studio'); return; }
        verify(e[0], sig).then(function (ok) {
          if (ok) say(e[1], 'seal-ok', 'STUDIO SEAL · VERIFIED IN THIS BROWSER · the studio signed punch ' + e[0] + ' · key ' + KEYHEX.slice(0, 8) + ' · sealed at ' + ix.build);
          else say(e[1], 'seal-no', 'STUDIO SEAL · FAILS · the signature on record is not the studio\'s for ' + e[0] + ' · treat this room as not the studio\'s');
        }).catch(function () { say(e[1], 'seal-none', 'STUDIO SEAL · THIS BROWSER CANNOT CHECK ED25519 · RUN seal.py verify FROM THE TOOLS'); });
      });
    }).catch(function () { els.forEach(function (e) { say(e[1], 'seal-none', 'STUDIO SEAL · THE INDEX DID NOT LOAD · RUN seal.py verify FROM THE TOOLS'); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.LundSeal = { verify: verify, key: KEY, keyHex: KEYHEX, run: run };
})();
